import { useParams } from 'react-router-dom';

type usePolicyParamsType = { policyId: string; termNumber?: string };

/**
 * Returns the current policy's policy id and termNumber from the URL params.
 * @return {usePolicyParamsType}
 */
export const usePolicyParams: () => usePolicyParamsType = () => {
  const { id: policyId, termNumber } = useParams<{
    id: string;
    termNumber?: string;
  }>();
  return {
    policyId,
    termNumber,
  };
};
